/* Stadium guide v2: sticky offset, video facade, contents highlight, "Add the whole Pack". */
(function () {
  var root = document;
  var base = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';

  // Keep the jump chips just under Horizon's sticky header.
  var header = document.querySelector('.header-section');
  var setTop = function () {
    if (!header || getComputedStyle(header).position !== 'sticky') return;
    var offset = parseFloat(getComputedStyle(header).top) || 0;
    document.documentElement.style.setProperty('--sg-sticky-top', header.offsetHeight + offset + 'px');
  };
  setTop();
  window.addEventListener('resize', setTop);

  // Video facade: load the iframe only on click. Probe the thumbnail: YouTube serves a
  // 120px placeholder for removed/private videos, so hide the whole block in that case.
  root.querySelectorAll('[data-sg-video]').forEach(function (block) {
    var id = block.getAttribute('data-sg-video');
    var hide = function () { block.hidden = true; };
    var probe = new Image();
    probe.onload = function () { if (probe.naturalWidth <= 120) hide(); };
    probe.onerror = hide;
    probe.src = 'https://i.ytimg.com/vi/' + encodeURIComponent(id) + '/hqdefault.jpg';
    block.querySelector('[data-sg-play]').addEventListener('click', function () {
      var frame = block.querySelector('.sg-video__frame');
      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) + '?autoplay=1&rel=0';
      iframe.title = this.getAttribute('aria-label');
      iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
      iframe.allowFullscreen = true;
      frame.innerHTML = '';
      frame.appendChild(iframe);
    });
  });

  // Highlight the section in view in the sidebar contents and the phone chips.
  var heads = root.querySelectorAll('.sg-body h2[id]');
  if (heads.length && 'IntersectionObserver' in window) {
    var links = root.querySelectorAll('.sg-toc a, .sg-chips a');
    var mark = function (id) {
      links.forEach(function (a) {
        var on = a.getAttribute('href') === '#' + id;
        a.classList.toggle('is-on', on);
        if (on) { a.setAttribute('aria-current', 'location'); } else { a.removeAttribute('aria-current'); }
        if (on && a.closest('.sg-chips')) a.scrollIntoView({ block: 'nearest', inline: 'center' });
      });
    };
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) mark(e.target.id); });
    }, { rootMargin: '-20% 0px -70% 0px' });
    heads.forEach(function (h) { io.observe(h); });
  }

  // "Add the whole Pack": add every available pick, then go to the cart.
  root.querySelectorAll('[data-sg-pack]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var items = btn.getAttribute('data-sg-pack').split(',').filter(Boolean).map(function (id) {
        return { id: Number(id), quantity: 1 };
      });
      btn.disabled = true;
      fetch(base + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { if (!r.ok) throw r; window.location.href = base + 'cart'; })
        .catch(function () { btn.disabled = false; });
    });
  });
})();
